import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

const StepProgressBar = ({ step, steps }) => {
  const percent = Math.round(((step + 1) / steps.length) * 100);

  return (
    <ProgressBar
      style={{ width: "100%", height: "3px", margin: "0", borderRadius: "0px" }}
    >
      <ProgressBar
        now={percent}
        animated
        striped
        style={{
          backgroundColor: "#000000",
          borderRadius: "0px",
        }}
      />
    </ProgressBar>
  );
};

export default StepProgressBar;
